/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Delivery/DeliveryOptions.Forms',[], function () {
    'use strict';

    // Forms fields configuration for data validation
    var forms = {
        addRecipient: {
            Fields: [
                {
                    "Name": 'First Name',
                    "Field": '.delivery-first-name',
                    "Param": 'firstName',
                    "Type": 'Text',
                    'Optional': true
                },
                {
                    "Name": 'Last Name',
                    "Field": '.delivery-last-name',
                    "Param": 'lastName',
                    "Type": 'Text',
                    'Optional': true
                },
                {
                    "Name": 'City',
                    "Field": '.delivery-city',
                    "Param": 'city',
                    "Type": 'Text',
                    'Optional': true
                },
                {
                    "Name": 'Country',
                    "Field": '.delivery-country',
                    "Param": 'country',
                    "Type": 'Text',
                    'Optional': true
                },
                {
                    "Name": 'Zip/Postal Code',
                    "Field": '.delivery-zip',
                    "Param": 'zip',
                    "Type": 'Text',
                    'Optional': true,
                    "Validators": [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '.delivery-country',
                                'ConditionalFieldAttr': 'data-isPostalCodeRequired',
                                'ConditionalValue': 'true',
                                'ConditionalFieldType': 'Select'
                            },
                        {
                            "Type": 'Zip',
                            'ReferencedField': '.delivery-country',
                            'ReferencedFieldAttr': 'data-isPostalCodeRequired',
                            'ReferencedValue': 'true',
                            'ReferencedFieldType': 'Select'
                        }
                    ]
                },
                {
                    "Name": 'State',
                    "Field": '#delivery-state',
                    "Param": 'state',
                    "Type": 'Hidden',
                    "Optional": true
                }
            ],
            Validate: true
        }
    };

    return forms;
});
